export default __webpack_public_path__ + "static/media/screenshot3_sm.5f15e83f.jpg";